import React, { useState, useEffect } from 'react';
import { processSteps } from '../mockData';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ProcessSteps = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % processSteps.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToNext = () => {
    setCurrentStep((prev) => (prev + 1) % processSteps.length);
    setIsAutoPlaying(false);
  };

  const goToPrevious = () => {
    setCurrentStep((prev) => (prev - 1 + processSteps.length) % processSteps.length);
    setIsAutoPlaying(false);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Simple 3-Step Process
          </h2>
          <p className="text-lg text-gray-600">
            We make Canadian trademark registration easy and stress-free
          </p>
        </div>

        {/* Desktop View - All Steps */}
        <div className="hidden md:grid md:grid-cols-3 gap-8">
          {processSteps.map((step, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
            >
              <div className="absolute -top-6 left-8 bg-teal-600 text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                {step.step}
              </div>
              <div className="mt-4">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile View - Slider */}
        <div className="md:hidden relative">
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border border-blue-100 min-h-[280px]">
            <div className="bg-teal-600 text-white w-16 h-16 rounded-full flex items-center justify-center text-2xl font-bold shadow-lg mb-6 mx-auto">
              {processSteps[currentStep].step}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
              {processSteps[currentStep].title}
            </h3>
            <p className="text-gray-600 leading-relaxed text-center">
              {processSteps[currentStep].description}
            </p>
          </div>

          {/* Mobile Navigation */}
          <div className="flex justify-center items-center mt-6 space-x-4">
            <button
              onClick={goToPrevious}
              className="bg-white hover:bg-gray-50 rounded-full p-2 shadow-md transition-all"
              aria-label="Previous step"
            >
              <ChevronLeft className="w-5 h-5 text-gray-700" />
            </button>
            
            <div className="flex space-x-2">
              {processSteps.map((_, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setCurrentStep(index);
                    setIsAutoPlaying(false);
                  }}
                  className={`transition-all duration-300 rounded-full ${
                    index === currentStep
                      ? 'bg-teal-600 w-8 h-3'
                      : 'bg-gray-300 w-3 h-3'
                  }`}
                  aria-label={`Go to step ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={goToNext}
              className="bg-white hover:bg-gray-50 rounded-full p-2 shadow-md transition-all"
              aria-label="Next step"
            >
              <ChevronRight className="w-5 h-5 text-gray-700" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
